import colors from '@constants/colors';

import { EventStatus } from './common';

export const EventStatusKr: Record<EventStatus, string> = {
    WAIT: '대기',
    ACTIVE: '진행중',
    CLOSED: '진행 종료',
};

export const EventStatusBadgeColor: Record<EventStatus, string> = {
    WAIT: colors.gray7,
    ACTIVE: colors.gray9,
    CLOSED: colors.gray7,
};
